export enum CouponType {
  APPSUMO2023 = 'appsumo2023',
  APPSUMO2020 = 'appsumo2020',
}

export interface OrgCoupons {
  isLoaded: boolean;
  isFetching: boolean;
  couponNumber: Record<string, number>;
}
